import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../config/msal";
import { useDispatch } from "react-redux";
import { setLoginInProcess } from "../../../redux/slices/user/userSlice";

export const SignInButton = () => {
    
    const dispatch = useDispatch();

    const { instance } = useMsal();

    const handleLogin = () => {
        dispatch({type:"RESET"});
        dispatch(setLoginInProcess(true));
        instance.loginRedirect(loginRequest);
    }

    return (
        <div>
            <button onClick={() => handleLogin()} className="header-principal-cesion-button" >
                Iniciar sesión
            </button>
        </div>
    );
}